import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "id", label: "User Id" },
	{ key: "firstName", label: "First Name" },
	{ key: "middleName", label: "Middle Name" },
	{ key: "lastName", label: "Last Name" },
	{ key: "email", label: "Email Address" },
	{ key: "phoneNumber", label: "Mobile Phone" },
	{ key: "workphone", label: "Work Phone" },
	{ key: "extension", label: "Office Extension" },
	{ key: "role", label: "Role" },
	{ key: "hireDate", label: "Hire Date" },
	{ key: "quitDate", label: "Quit Date" },
	{ key: "ssn", label: "SSN" },
	{ key: "birthDay", label: "Birthday" },
	{ key: "creatorId", label: "Creator" },
	{ key: "createdAt", label: "Created At" }, 
	{ key: "updaterId", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
	{ key: "personel", label: "Personel" },
	{ key: "office", label: "Office" },
	{ key: "allOffice", label: "All Office" },
	{ key: "background", label: "Background" }
];
export default function UserExportForm(){
	return (<ExportForm columns = {EXPORT_COLUMNS}/>);
}